(ns scittle.mathbox
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [mathbox.core]
    [mathbox.primitives]))

;; Plugin: mathbox
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::mathbox
   {:namespaces
   {'mathbox.core (sci/copy-ns mathbox.core (sci/create-ns 'mathbox.core nil))
    'mathbox.primitives (sci/copy-ns mathbox.primitives (sci/create-ns 'mathbox.primitives nil))}}
   ))
